module.exports = __webpack_public_path__ + "static/media/Education Scirpt_v2_1634048680102.d5cfb3f4.docx";